import {
  Container,
  Box,
  Button,
  useMediaQuery,
  Divider,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  tableCellClasses,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { useWeb3React } from "@web3-react/core";
import CopyToClipboard from "react-copy-to-clipboard";
import { toast } from "react-toastify";
import { useStakingContract, useStakingContract1 } from "../hooks";
import Loading from "../loading";
import { formatUnits } from "@ethersproject/units";
import { styled } from "@mui/material/styles";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    color: theme.palette.common.white,
    paddingTop: 10,
    paddingBottom: 10,
    paddingLeft: 1,
    paddingRight: 1,
  },
  [`&.${tableCellClasses.body}`]: {
    paddingTop: 10,
    paddingBottom: 10,
    paddingLeft: 0,
    paddingRight: 0,
  },
}));
// const StyledTableRow = styled(TableRow)(({ theme }) => ({
//   "&:nth-of-type(odd)": {
//     backgroundColor: theme.palette.action.hover,
//   },
//   "&:last-child td, &:last-child th": {
//     border: 0,
//   },
// }));

function Dashboard() {
  const matches = useMediaQuery("(max-width:750px)");
  const { account } = useWeb3React();
  const stakingContract = useStakingContract();
  const stakingContract1 = useStakingContract1();

  const [loading, setloading] = useState(false);
  const [totalInvested, settotalInvested] = useState(0);
  const [totalRefralReward, settotalRefralReward] = useState(0);
  const [totalWithdrawn, settotalWithdrawn] = useState(0);
  const [totalWithdrawable, settotalWithdrawable] = useState(0);
  const [level1, setlevel1] = useState(0);
  const [level2, setlevel2] = useState(0);
  const [level3, setlevel3] = useState(0);
  const [level4, setlevel4] = useState(0);
  const [level5, setlevel5] = useState(0);
  const [stakeDetails, setstakeDetails] = useState([]);
  const [planArray, setplanArray] = useState([]);

  const initDetails = async () => {
    if (account) {
      try {
        var { stake_count } = await stakingContract.users(account);

        if (+stake_count > 0) {
          const arr = [];
          for (let i = 1; i < +stake_count; i++) {
            const stakedetails1 = await stakingContract.userInfo(
              account,
              i.toString()
            );
            let depositAmount = +formatUnits(
              stakedetails1.deposit_amount.toString(),
              18
            );
            let bonusAmount = +formatUnits(stakedetails1.bonus.toString(), 18);
            let arrayPlan = initPlan(depositAmount, bonusAmount);
            const obj = {
              deposit_amount: depositAmount,
              withdrawn_amount: +formatUnits(
                stakedetails1.withdrawn_amount.toString(),
                18
              ),
              bonus: bonusAmount,
            };
            setplanArray(arrayPlan);

            if (obj.deposit_amount !== 0 && obj.bonus !== 0) {
              arr.push(obj);
            }
          }
          setstakeDetails([...arr]);
        }
      } catch (error) {
        console.log(error);
      }
    } else {
      setstakeDetails([]);
    }
  };
  const initPlan = (depositAmount, bonus) => {
    let bonus_percentage = 140;
    for (let i = 0; i <= 23; i++) {
      let bonusPlanPercentage = bonus_percentage + i * 6.9;
      let finalPlanPercentage = (bonusPlanPercentage * depositAmount) / 100;
      if (bonus.toFixed(5) == finalPlanPercentage.toFixed(5)) {
        return [bonusPlanPercentage, i + 7];
      }
    }
    return [0, 0];
  };
  useEffect(() => {
    if (account) {
      initDetails();
    }
  }, [account]);

  const init = async () => {
    const totalInfo = await stakingContract1.methods
      .userInfoTotals(account)
      .call();
    settotalRefralReward(formatUnits(totalInfo[0]));
    settotalInvested(formatUnits(totalInfo[1]));
    settotalWithdrawn(formatUnits(totalInfo[2]));

    const levels = await stakingContract1.methods
      .userReferralsInfo(account)
      .call();
    setlevel1(levels[0]);
    setlevel2(levels[1]);
    setlevel3(levels[2]);
    setlevel4(levels[3]);
    setlevel5(levels[4]);
  };
  useEffect(() => {
    if (account) {
      init();
    }
  }, [account]);

  const initWitdrawable = async () => {
    const totalWithdrawableBNB = await stakingContract1.methods
      .payoutOf(account)
      .call();
    settotalWithdrawable(formatUnits(totalWithdrawableBNB));
  };
  useEffect(() => {
    const interval = setInterval(() => {
      if (account) {
        initWitdrawable();
      }
    }, 5000);
    return () => clearInterval(interval);
  }, [account]);

  const withdrawHandler = async () => {
    if (account) {
      if (+totalWithdrawable === 0) {
        toast.error("Error! withdrawable amount must be > 0");
      } else {
        try {
          setloading(true);
          const tx = await stakingContract.withdraw();
          await tx.wait();
          toast.success("Success! Withdraw successfully done.");
          init();
          setloading(false);
        } catch (error) {
          if (error?.data?.message) {
            toast.error(error?.data?.message);
          } else {
            toast.error(error?.message);
          }
          setloading(false);
        }
      }
    } else {
      toast.error("Error! Please connect your wallet.");
    }
  };

  const re_stakeHandeler = async () => {
    if (account) {
      if (+totalRefralReward === 0) {
        toast.error("Error! Referral reward must be > 0");
      } else {
        try {
          setloading(true);
          const tx = await stakingContract.restake_referrals_bonus();
          await tx.wait();
          toast.success("Success! Transaction confirmed.");
          setloading(false);
        } catch (error) {
          if (error?.data?.message) {
            toast.error(error?.data?.message);
          } else {
            toast.error(error?.message);
          }
          setloading(false);
        }
      }
    } else {
      toast.error("Error! Please connect your wallet.");
    }
  };
  const ref_withdrawhandler = async () => {
    if (account) {
      if (+totalRefralReward === 0) {
        toast.error("Error! Referral reward must be > 0");
      } else {
        try {
          setloading(true);
          const tx = await stakingContract.withdraw_referrals_bonus();
          await tx.wait();
          toast.success("Success! Transaction confirmed.");
          setloading(false);
        } catch (error) {
          if (error?.data?.message) {
            toast.error(error?.data?.message);
          } else {
            toast.error(error?.message);
          }
          setloading(false);
        }
      }
    } else {
      toast.error("Error! Please connect your wallet.");
    }
  };
  return (
    <Box mt={10} position="relative" zIndex={2}>
      <Loading loading={loading} />
      <Container maxWidth="lg">
        <Box
          fontSize={{ xs: "30px", sm: "36px" }}
          fontWeight={700}
          lineHeight="80.86px"
          color="text.primary"
          textAlign="center"
          mt={5}
        >
          DASHBOARD
        </Box>
        <Box
          bgcolor="rgba(238, 190, 98, 0.12)"
          borderRadius="12px"
          border="2px solid #eebe62"
          sx={{ backdropFilter: "blur(20px)" }}
          width="100%"
          padding="50px 30px"
        >
          <Box
            display="flex"
            justifyContent={matches ? "center" : "space-between"}
            alignItems="center"
            width="100%"
            flexWrap="wrap"
          >
            <Box
              bgcolor="rgba(238, 190, 98, 0.12)"
              borderRadius="12px"
              border="2px solid #eebe62"
              sx={{ backdropFilter: "blur(33px)" }}
              width={matches ? "100%" : "210px"}
              height="118px"
              display="flex"
              justifyContent="center"
              alignItems="center"
              flexDirection="column"
              mt={2}
            >
              <Box>Withdrawable</Box>
              <Box>{parseFloat(totalWithdrawable).toFixed(3)} BNB</Box>
            </Box>

            <Box
              bgcolor="rgba(238, 190, 98, 0.12)"
              borderRadius="12px"
              border="2px solid #eebe62"
              sx={{ backdropFilter: "blur(33px)" }}
              width={matches ? "100%" : "210px"}
              height="118px"
              display="flex"
              justifyContent="center"
              alignItems="center"
              flexDirection="column"
              mt={2}
            >
              <Box>Total Invested</Box>
              <Box>{parseFloat(totalInvested).toFixed(3)} BNB</Box>
            </Box>

            <Box
              bgcolor="rgba(238, 190, 98, 0.12)"
              borderRadius="12px"
              border="2px solid #eebe62"
              sx={{ backdropFilter: "blur(33px)" }}
              width={matches ? "100%" : "210px"}
              height="118px"
              display="flex"
              justifyContent="center"
              alignItems="center"
              flexDirection="column"
              mt={2}
            >
              <Box>Total Withdrawal</Box>
              <Box>{parseFloat(totalWithdrawn).toFixed(3)} BNB</Box>
            </Box>

            <Box
              bgcolor="rgba(238, 190, 98, 0.12)"
              borderRadius="12px"
              border="2px solid #eebe62"
              sx={{ backdropFilter: "blur(33px)" }}
              width={matches ? "100%" : "210px"}
              height="118px"
              display="flex"
              justifyContent="center"
              alignItems="center"
              flexDirection="column"
              position="relative"
              mt={2}
            >
              <Box>Total Referral Reward</Box>
              <Box>{parseFloat(totalRefralReward).toFixed(3)} BNB</Box>
              <Box
                position="absolute"
                bottom={-15}
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                <Button
                  sx={{
                    width: "100px",
                    height: "35px",
                    borderRadius: "48px",
                    border: "2px solid #EEBE62",
                    background:
                      "linear-gradient(94.25deg, #EEBE62 0%, #9C702A 31.82%, #EEBE62 75.71%, #9C702A 98%)",
                    backdropFilter: "blur(20px)",
                    textTransform: "capitalize",
                    color: "#FDFCFC",
                    fontSize: matches ? "10px" : "15px",
                    fontWeight: 700,
                    // position: "absolute",
                    // bottom: "-15px",
                  }}
                  onClick={() => re_stakeHandeler()}
                >
                  Re-Invest
                </Button>
                <Button
                  sx={{
                    width: "100px",
                    height: "35px",
                    borderRadius: "48px",
                    border: "2px solid #EEBE62",
                    background:
                      "linear-gradient(94.25deg, #EEBE62 0%, #9C702A 31.82%, #EEBE62 75.71%, #9C702A 98%)",
                    backdropFilter: "blur(20px)",
                    textTransform: "capitalize",
                    color: "#FDFCFC",
                    fontSize: matches ? "10px" : "15px",
                    fontWeight: 700,
                    marginLeft: "10px",
                    // position: "absolute",
                    // bottom: "-15px",
                  }}
                  onClick={() => ref_withdrawhandler()}
                >
                  Withdraw
                </Button>
              </Box>
            </Box>
          </Box>

          <Box
            mt={15}
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <Button
              sx={{
                width: "262px",
                height: "62px",
                borderRadius: "48px",
                border: "2px solid #EEBE62",
                background:
                  "linear-gradient(94.25deg, #EEBE62 0%, #9C702A 31.82%, #EEBE62 75.71%, #9C702A 98%)",
                backdropFilter: "blur(20px)",
                textTransform: "capitalize",
                color: "#FDFCFC",
                fontSize: matches ? "20px" : "24px",
                fontWeight: 700,
                position: "absolute",
              }}
              onClick={() => withdrawHandler()}
            >
              Withdraw
            </Button>
          </Box>
          <hr
            style={{
              border: "1px solid #eebe62",
              position: "relative",
              marginTop: "0px",
              zIndex: -1,
            }}
          />

          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            flexDirection={matches ? "column" : "row"}
            mt={7}
            fontSize="18px"
            fontWeight={300}
            textAlign="center"
          >
            Your Referral Link:
            <Box ml={1} fontWeight={500} component="span">
              {window.location.origin +
                "/?ref=" +
                (account
                  ? account.slice(0, 6) + "..." + account.slice(-4)
                  : "Connect your wallet")}
            </Box>
            <CopyToClipboard
              style={{
                cursor: "pointer",
                marginLeft: "8px",
              }}
              text={window.location.origin + "/?ref=" + account}
              onCopy={() => {
                account
                  ? toast.success("Referral link copied!")
                  : toast.error("Error! Please connect your wallet!");
              }}
            >
              <ContentCopyIcon color="#fff" fontSize="18px" />
            </CopyToClipboard>
          </Box>
          <Box display="flex" alignItems="center" flexDirection="column">
            <Box
              mt={6}
              mb={3}
              style={{
                color: "#ffffff",
                fontSize: matches ? "25px" : "35px",
                fontWeight: "600",
              }}
            >
              STAKE HISTORY
            </Box>

            <TableContainer
              component={Box}
              borderRadius="15px"
              border="2px solid #EEBE62"
              color="#000000"
            >
              <Table
                aria-label="simple table"
                style={{ borderRadius: "10px", marginTop: "0px" }}
                color="#EEBE62"
              >
                <TableHead color="#EEBE62">
                  <TableRow style={{ color: "#ffffff" }}>
                    <StyledTableCell
                      align="center"
                      style={{
                        color: "#fff",
                        fontSize: matches ? "11px" : "18px",
                      }}
                    >
                      S/N
                    </StyledTableCell>
                    <StyledTableCell
                      align="center"
                      style={{
                        color: "#fff",
                        fontSize: matches ? "10px" : "18px",
                      }}
                    >
                      Period
                    </StyledTableCell>
                    <StyledTableCell
                      align="center"
                      style={{
                        color: "#fff",
                        fontSize: matches ? "10px" : "18px",
                      }}
                    >
                      STAKED
                    </StyledTableCell>
                    <StyledTableCell
                      align="center"
                      style={{
                        color: "#fff",
                        fontSize: matches ? "10px" : "18px",
                      }}
                    >
                      Bonus %
                    </StyledTableCell>
                    <StyledTableCell
                      align="center"
                      style={{
                        color: "#fff",
                        fontSize: matches ? "10px" : "18px",
                      }}
                    >
                      WITHDRAWN
                    </StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {stakeDetails.length !== 0 ? (
                    stakeDetails.map(
                      ({ deposit_amount, withdrawn_amount, bonus }, index) => (
                        <TableRow>
                          <StyledTableCell
                            align="center"
                            style={{
                              color: "#fff",
                              fontSize: matches ? "10px" : "18px",
                            }}
                          >
                            {index + 1}
                          </StyledTableCell>
                          <StyledTableCell
                            align="center"
                            style={{
                              color: "#fff",
                              fontSize: matches ? "10px" : "18px",
                            }}
                          >
                            {planArray[1]} Days
                          </StyledTableCell>
                          <StyledTableCell
                            align="center"
                            style={{
                              color: "#fff",
                              fontSize: matches ? "10px" : "18px",
                            }}
                          >
                            {deposit_amount} BNB
                          </StyledTableCell>
                          <StyledTableCell
                            align="center"
                            style={{
                              color: "#fff",
                              fontSize: matches ? "10px" : "18px",
                            }}
                          >
                            {parseFloat(planArray[0]).toFixed(2)} %
                          </StyledTableCell>
                          <StyledTableCell
                            align="center"
                            style={{
                              color: "#fff",
                              fontSize: matches ? "10px" : "18px",
                            }}
                          >
                            {parseFloat(withdrawn_amount).toFixed(2)} BNB
                          </StyledTableCell>
                        </TableRow>
                      )
                    )
                  ) : (
                    <TableRow>
                      <StyledTableCell
                        align="center"
                        style={{
                          color: "#ffffff",
                          fontSize: matches ? "10px" : "18px",
                        }}
                        colSpan={5}
                      >
                        You have no staking history yet
                      </StyledTableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
          <Box
            display="flex"
            justifyContent={matches ? "center" : "space-between"}
            alignItems="center"
            width="100%"
            flexWrap="wrap"
            mt={7}
            mb={2}
          >
            <Box
              width={matches ? "100%" : "167px"}
              height="102px"
              borderRadius="13px"
              border="2px solid #EEBE62"
              sx={{
                background:
                  "linear-gradient(94.25deg, #EEBE62 0%, #9C702A 31.82%, #EEBE62 75.71%, #9C702A 98%)",
                backdropFilter: "blur(20px)",
              }}
              display="flex"
              alignItems="center"
              justifyContent="center"
              flexDirection="column"
              fontSize="24px"
              fontWeight={700}
              mt={2}
            >
              1 LVL{" "}
              <Box fontSize="14px" fontWeight={400}>
                {level1} referrals
              </Box>
              <Box fontSize="14px" fontWeight={400}>
                5% Referral Rewards
              </Box>
            </Box>

            <Box
              width={matches ? "100%" : "167px"}
              height="102px"
              borderRadius="13px"
              border="2px solid #EEBE62"
              sx={{
                background:
                  "linear-gradient(94.25deg, #EEBE62 0%, #9C702A 31.82%, #EEBE62 75.71%, #9C702A 98%)",
                backdropFilter: "blur(20px)",
              }}
              display="flex"
              alignItems="center"
              justifyContent="center"
              flexDirection="column"
              fontSize="24px"
              fontWeight={700}
              mt={2}
            >
              2 LVL{" "}
              <Box fontSize="14px" fontWeight={400}>
                {level2} referrals
              </Box>
              <Box fontSize="14px" fontWeight={400}>
                3% Referral Rewards
              </Box>
            </Box>

            <Box
              width={matches ? "100%" : "167px"}
              height="102px"
              borderRadius="13px"
              border="2px solid #EEBE62"
              sx={{
                background:
                  "linear-gradient(94.25deg, #EEBE62 0%, #9C702A 31.82%, #EEBE62 75.71%, #9C702A 98%)",
                backdropFilter: "blur(20px)",
              }}
              display="flex"
              alignItems="center"
              justifyContent="center"
              flexDirection="column"
              fontSize="24px"
              fontWeight={700}
              mt={2}
            >
              3 LVL{" "}
              <Box fontSize="14px" fontWeight={400}>
                {level3} referrals
              </Box>
              <Box fontSize="14px" fontWeight={400}>
                2% Referral Rewards
              </Box>
            </Box>

            <Box
              width={matches ? "100%" : "167px"}
              height="102px"
              borderRadius="13px"
              border="2px solid #EEBE62"
              sx={{
                background:
                  "linear-gradient(94.25deg, #EEBE62 0%, #9C702A 31.82%, #EEBE62 75.71%, #9C702A 98%)",
                backdropFilter: "blur(20px)",
              }}
              display="flex"
              alignItems="center"
              justifyContent="center"
              flexDirection="column"
              fontSize="24px"
              fontWeight={700}
              mt={2}
            >
              4 LVL{" "}
              <Box fontSize="14px" fontWeight={400}>
                {level4} referrals
              </Box>
              <Box fontSize="14px" fontWeight={400}>
                1% Referral Rewards
              </Box>
            </Box>

            <Box
              width={matches ? "100%" : "167px"}
              height="102px"
              borderRadius="13px"
              border="2px solid #EEBE62"
              sx={{
                background:
                  "linear-gradient(94.25deg, #EEBE62 0%, #9C702A 31.82%, #EEBE62 75.71%, #9C702A 98%)",
                backdropFilter: "blur(20px)",
              }}
              display="flex"
              alignItems="center"
              justifyContent="center"
              flexDirection="column"
              fontSize="24px"
              fontWeight={700}
              mt={2}
            >
              5 LVL{" "}
              <Box fontSize="14px" fontWeight={400}>
                {level5} referrals
              </Box>
              <Box fontSize="14px" fontWeight={400}>
                0.5% Referral Rewards
              </Box>
            </Box>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}

export default Dashboard;
